import NetResourceRepository from '../NetResourceRepository';
import NetResourceRepositoryAdapter from '../NetResourceRepositoryAdapter';

import CurrentUserMapper, {
  CurrentUserData,
} from '../../entities/mappers/writer/CurrentUserMapper';

import CurrentUser from '../../../domain/entities/writer/CurrentUser';
import CurrentUserRepository from '../../../domain/repositories/writer/CurrentUserRepository';

export default class NetCurrentUserRepository
  extends NetResourceRepository<CurrentUser, CurrentUserData>
  implements CurrentUserRepository
{
  constructor() {
    super(
      new NetResourceRepositoryAdapter(
        '/api/writer/current_user',
        new CurrentUserMapper(),
      ),
    );
  }
}
